import React, { createContext, useContext, useCallback } from 'react';



const CartUiContext = createContext(null);

export function useCartUi() {

  const ctx = useContext(CartUiContext);

  if (!ctx) {

    return {

      flyToCart: () => {},

      flyFromCart: () => {},

      pulseCartIcon: () => {},

      bumpCartIcon: () => {},

    };

  }

  return ctx;

}



function getCartTarget() {

  if (typeof document === 'undefined') return null;

  return document.getElementById('np-cart-fly-target');

}



/** Rebote / pulso del icono del carrito: 'add' (verde) o 'remove' (rojo) */

/** Pulso en el carrito del navbar (React en Navbar escucha cart:pulse) */
export function pulseCartIcon(mode = 'add') {
  window.dispatchEvent(new CustomEvent('cart:pulse', { detail: { mode } }));
  window.dispatchEvent(new CustomEvent('cart:bump', { detail: { mode } }));
}



/** @deprecated usar pulseCartIcon('add') */

export function bumpCartIcon() {

  pulseCartIcon('add');

}



/**
 * Anima hacia el carrito: imagen del producto o icono de bolsa.
 * @param {{ imageSrc?: string, fromEl?: Element | null, fromRect?: DOMRect, useBagIcon?: boolean }} opts
 */
export function flyToCart({ imageSrc, fromEl, fromRect, useBagIcon = false }) {
  if (typeof document === 'undefined') return;

  const target = getCartTarget();
  if (!target || (!fromEl && !fromRect)) return;

  const from = fromRect || fromEl.getBoundingClientRect();
  const to = target.getBoundingClientRect();

  const size = useBagIcon || !imageSrc ? 40 : 56;
  const startX = from.left + from.width / 2 - size / 2;
  const startY = from.top + from.height / 2 - size / 2;
  const endX = to.left + to.width / 2 - size / 2;
  const endY = to.top + to.height / 2 - size / 2;

  const fly = document.createElement('div');
  fly.className = useBagIcon || !imageSrc ? 'np-cart-fly np-cart-fly--bag' : 'np-cart-fly np-cart-fly--to-cart';
  fly.style.left = `${startX}px`;
  fly.style.top = `${startY}px`;
  fly.style.setProperty('--tx', `${endX - startX}px`);
  fly.style.setProperty('--ty', `${endY - startY}px`);

  if (useBagIcon || !imageSrc) {
    fly.innerHTML = '<i class="bi bi-bag-fill" aria-hidden="true"></i>';
  } else {
    const img = document.createElement('img');
    img.src = imageSrc;
    img.alt = '';
    fly.appendChild(img);
  }

  document.body.appendChild(fly);
  const cleanup = () => fly.remove();
  fly.addEventListener('animationend', cleanup, { once: true });
  window.setTimeout(cleanup, 1200);
}



/**

 * Anima una miniatura desde el carrito hacia el producto (al quitar).

 * @param {{ imageSrc: string, toEl?: Element | null, toRect?: DOMRect }} opts

 */

export function flyFromCart({ imageSrc, toEl, toRect, useBagIcon = false }) {
  if (typeof document === 'undefined') return;
  if (!useBagIcon && !imageSrc) return;

  const target = getCartTarget();
  if (!target || (!toEl && !toRect)) return;

  const from = target.getBoundingClientRect();
  const to = toRect || toEl.getBoundingClientRect();

  const bag = useBagIcon || !imageSrc;
  const size = bag ? 40 : 48;
  const startX = from.left + from.width / 2 - size / 2;
  const startY = from.top + from.height / 2 - size / 2;
  const endX = to.left + to.width / 2 - size / 2;
  const endY = to.top + to.height / 2 - size / 2;

  const fly = document.createElement('div');
  fly.className = bag
    ? 'np-cart-fly np-cart-fly--bag np-cart-fly--from-cart'
    : 'np-cart-fly np-cart-fly--from-cart';
  fly.style.left = `${startX}px`;
  fly.style.top = `${startY}px`;
  fly.style.setProperty('--tx', `${endX - startX}px`);
  fly.style.setProperty('--ty', `${endY - startY}px`);

  if (bag) {
    fly.innerHTML = '<i class="bi bi-bag-fill" aria-hidden="true"></i>';
  } else {
    const img = document.createElement('img');
    img.src = imageSrc;
    img.alt = '';
    fly.appendChild(img);
  }

  document.body.appendChild(fly);
  const cleanup = () => fly.remove();
  fly.addEventListener('animationend', cleanup, { once: true });
  window.setTimeout(cleanup, 1000);
}



/** Toast de éxito al agregar al carrito */

export function showCartAddedToast(productName) {

  if (typeof document === 'undefined') return;

  document.querySelector('.np-cart-toast-success')?.remove();



  const el = document.createElement('div');

  el.className = 'np-cart-toast-success';

  el.setAttribute('role', 'status');

  el.innerHTML = '<i class="bi bi-bag-check-fill me-2" aria-hidden="true"></i><span></span>';

  const textSpan = el.querySelector('span');

  const name = String(productName || '').trim();

  if (textSpan) {

    textSpan.textContent = name ? `${name} agregado al carrito` : 'Producto agregado al carrito';

  }

  document.body.appendChild(el);

  window.setTimeout(() => {

    el.classList.add('np-cart-toast-success--out');

    window.setTimeout(() => el.remove(), 320);

  }, 2400);

}



/** Toast inferior breve para errores de stock (sin SweetAlert) */

export function showCartToast(message) {

  if (typeof document === 'undefined') return;

  document.querySelector('.np-cart-toast-error')?.remove();



  const el = document.createElement('div');

  el.className = 'np-cart-toast-error';

  el.setAttribute('role', 'alert');

  el.innerHTML = '<i class="bi bi-exclamation-circle me-2" aria-hidden="true"></i><span></span>';

  const textSpan = el.querySelector('span');

  if (textSpan) textSpan.textContent = String(message ?? '');

  document.body.appendChild(el);

  window.setTimeout(() => {

    el.style.pointerEvents = 'none';

    el.remove();

  }, 2800);

}



export function CartUiProvider({ children }) {

  const fly = useCallback((opts) => flyToCart(opts), []);

  const flyBack = useCallback((opts) => flyFromCart(opts), []);

  const pulse = useCallback((mode) => pulseCartIcon(mode), []);

  const bump = useCallback(() => pulseCartIcon('add'), []);



  const value = {

    flyToCart: fly,

    flyFromCart: flyBack,

    pulseCartIcon: pulse,

    bumpCartIcon: bump,

  };



  return <CartUiContext.Provider value={value}>{children}</CartUiContext.Provider>;

}


